<template>
  <div ref="menu-container" class="overflow-hidden" :class="addClassSticky ? 'sticky' : ''">
    <template v-if="$store.state.guestCurrentRole === guestUserRoles.ROLE_RECRUITER">
      <pre-paywall-recruiter-menu-items/>
    </template>
    <template v-else-if="$store.state.guestCurrentRole === guestUserRoles.ROLE_PHYSICIAN">
      <pre-paywall-menu-items/>
    </template>
  </div>
</template>

<script>
import PrePaywallMenuItems from '@/components/layouts/pre-paywall/PrePaywallMenuItems';
import ImageUrlMixin from '@/mixins/ImageUrlMixin';
import PrePaywallRecruiterMenuItems from "@/components/layouts/pre-paywall/PrePaywallRecruiterMenuItems";
import {GUEST_USER_ROLES} from "@/store";

export default {
  name: 'PrePaywallLayout',
  mixins: [ImageUrlMixin],
  components: {
    PrePaywallMenuItems,
    PrePaywallRecruiterMenuItems,
  },
  data() {
    return {
      guestUserRoles: GUEST_USER_ROLES,
      addClassSticky: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll: function () {
      let scrollHeight = this.$refs["menu-container"].scrollHeight;
      let scrollTop = window.pageYOffset;
      this.addClassSticky = scrollTop > scrollHeight;
    }
  },
};
</script>

<style scoped>
.breadcrumbs-container {
  margin-top: 10px;
  margin-bottom: 15px;
}

.sticky {
  position: fixed;
  top: 56px;
  width: 100%;
  z-index: 100;
  background-color: #FFFFFF;
}
</style>
